import React from "react";

// ---------------------------------------------------------------------------
// Review-queue banner rendered above the Realtors table when the Review sub-
// tab is active. Explains what the queue is for, shows the pending count,
// and exposes bulk Approve/Reject actions targeting the current selection.
// Empty state ("caught up!") also lives here so the tab itself never looks
// broken to a user who scans regularly.
// ---------------------------------------------------------------------------
export default function ReviewQueueBanner({ summary, selected, busy, onApproveSelected, onRejectSelected }) {
  const count = Number(summary?.pending) || 0;
  const selectedCount = selected?.size || 0;
  if (count === 0) {
    return (
      <div
        className="rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-900"
        data-testid="review-queue-empty-banner"
      >
        <strong>Review queue is empty.</strong> New realtors discovered by an open-house
        scan land here so you can clean up their contact info + enrich socials
        before promoting them to the main list.
      </div>
    );
  }
  return (
    <div
      className="rounded-lg border border-rose-200 bg-rose-50 px-4 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
      data-testid="review-queue-banner"
    >
      <div className="text-sm text-rose-900">
        <strong>{count} new realtor{count === 1 ? "" : "s"} waiting for review.</strong>{" "}
        Discovered by an open-house scan — enrich socials + verify contact info,
        then approve to add them to the main list. Reject soft-deletes.
      </div>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={onRejectSelected}
          disabled={busy || selectedCount === 0}
          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-md border border-rose-300 bg-white text-rose-700 text-sm font-medium hover:bg-rose-100 disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid="review-reject-selected"
        >
          Reject {selectedCount > 0 ? `(${selectedCount})` : ""}
        </button>
        <button
          type="button"
          onClick={onApproveSelected}
          disabled={busy || selectedCount === 0}
          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-md border border-emerald-600 bg-emerald-600 text-white text-sm font-medium hover:bg-emerald-700 disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid="review-approve-selected"
        >
          Approve {selectedCount > 0 ? `(${selectedCount})` : ""}
        </button>
      </div>
    </div>
  );
}
